import { render, staticRenderFns } from "./TheFilters.vue?vue&type=template&id=32d2153b&scoped=true"
import script from "./TheFilters.vue?vue&type=script&lang=js"
export * from "./TheFilters.vue?vue&type=script&lang=js"
import style0 from "./TheFilters.vue?vue&type=style&index=0&id=32d2153b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d2153b",
  null
  
)

export default component.exports